/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Contact_Association_InvalidInputs */

const en_error_contact_association_invalid = /** @type {(inputs: Error_Contact_Association_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The contact cannot be associated with this company:`)
};

/**
* | output |
* | --- |
* | "The contact cannot be associated with this company:" |
*
* @param {Error_Contact_Association_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_contact_association_invalid = /** @type {((inputs?: Error_Contact_Association_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Contact_Association_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_contact_association_invalid(inputs)
});